﻿import { onlyDigits, setCaretPosition } from "@js/core/utils/text";

export function formatIdentity(value) {
    const digits = onlyDigits(value).substring(0, 11);

    if (digits.length > 10) {
        // TCKN: XX XX XX XX XXX
        return digits.replace(
            /^(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,3}).*$/,
            (_, a, b, c, d, e) => [a, b, c, d, e].filter(Boolean).join(" ")
        );
    }

    // VKN: XXX XXX XX XX
    return digits.replace(
        /^(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2}).*$/,
        (_, a, b, c, d) => [a, b, c, d].filter(Boolean).join(" ")
    );
}

export function initIdentityMask(selector = ".js-vkn-tckn") {
    const inputs = document.querySelectorAll(selector);
    if (!inputs.length) return;

    inputs.forEach((input) => {
        input.addEventListener("input", () => {
            const rawDigits = onlyDigits(input.value).substring(0, 11);
            const formatted = formatIdentity(rawDigits);

            input.value = formatted;
            setCaretPosition(input, input.value.length);
        });

        input.addEventListener("paste", (e) => {
            e.preventDefault();

            const pasted = e.clipboardData?.getData("text") || "";
            const digits = onlyDigits(pasted).substring(0, 11);

            input.value = formatIdentity(digits);
            setCaretPosition(input, input.value.length);
            input.dispatchEvent(new Event("input", { bubbles: true }));
        });

        input.addEventListener("blur", () => {
            input.value = formatIdentity(input.value);
        });
    });
}

export function initOrderMask(selector = ".js-order-no") {
    if (!window.jQuery || !window.jQuery.fn?.inputmask) return;

    const $ = window.jQuery;
    const $order = $(selector);

    if (!$order.length) return;

    $order.inputmask({
        mask: "99999",
        placeholder: "",
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: false,
        jitMasking: true
    });
}